module.exports = __webpack_public_path__ + "static/media/male2.d2665e7c.jpg";